module.exports = __webpack_public_path__ + "images/10.97fab91e.jpg";